import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class ShortcutDropdown extends Component {
  render() {
    const {
      form,
      multiple,
      name,
      onPostChange,
      preload = true,
      searchFn,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType="shortcut"
          type="shortcut"
          preload={preload}
          valueField="id"
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
          onPostChange={onPostChange}
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(ShortcutDropdown);
